import { useEffect, useState } from 'react';
import type { CapabilityReport } from '@estudio/contracts';
import { useServices } from './services.tsx';

export function useOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

export function useCapabilities(): CapabilityReport | null {
  const { bridge } = useServices();
  const [report, setReport] = useState<CapabilityReport | null>(null);
  useEffect(() => {
    let alive = true;
    void bridge.getCapabilities().then((r) => alive && setReport(r));
    const off = bridge.subscribe((e) => {
      if (e.type === 'capabilities_changed') setReport(e.report);
    });
    return () => {
      alive = false;
      off();
    };
  }, [bridge]);
  return report;
}

export function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function readFileText(file: File): Promise<string> {
  return file.text();
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · PromptCut` : 'PromptCut';
  }, [title]);
}
